import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},
    {key:'orgName', label: '部门', width: 150},
    {key:'userCode', label: '工(学)号', width: 120},
    {key:'userName', label: '姓名', width: 120},
    {key:'bgTermName', label: '开始学期'},
    {key:'endTermName', label: '结束学期'}
]);

const header2 = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},
    {key:'sumCount', label: '应填报人数', width: 95},
    {key:'fillingCount', label: '实际填报人数', width: 95},
    {key:'fillingRate', label: '填报人数占比', width: 120},
    {key:'bgTermName', label: '开始学期'},
    {key:'endTermName', label: '结束学期'}
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {

    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('zgcp/result/analysis/filling/total/list?' + params.join('&'),   Object.assign(defaultsParams, keywords))
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta
        };
    })
    .then(response => (Object.assign({
        meta: response.meta,
        result: response.data.dataList || [],
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize: response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

export default {
    querySearch,
    headers,
    header2,
    onSelect,
    setRefresh,
}